import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addProductToList } from "../../../server/ShoppingList";
import showAlert from "../../../server/ShowAlert";
import { setPreload } from "../../../server/CartsOpen";
import { NavLink } from "react-router-dom";
import { customerListId } from "../../../server/ShoppingList";

const ProductAddToShoppingList = ({ selectedProd, close, onAddSuccess }) => {
  const dispatch = useDispatch();
  const listNames = useSelector((state) => state.shoppingList.shoppingList);
  const [chosenList, setChosenList] = useState(
    listNames.length > 0 ? listNames[0].id : null,
  );
  const [quantityAddToShopList, setQuantityAddToShopList] = useState(
    parseInt(selectedProd.weightJump) > 0
      ? parseInt(selectedProd.weightJump)
      : 1,
  );
  const weightJump =
    parseInt(selectedProd.weightJump) > 0
      ? parseInt(selectedProd.weightJump)
      : 1;
  useEffect(() => {
    if (!chosenList) return;

    customerListId(chosenList)
      .then((x) => {
        const items = x.data?.items ?? [];

        const inList = items.find(
          (item) => item.productId === selectedProd.productId,
        );

        if (inList) {
          setQuantityAddToShopList(inList.quantity);
        } else {
          setQuantityAddToShopList(weightJump);
        }
      })
      .catch((e) => console.log("error", e));
  }, [chosenList, selectedProd.productId, weightJump]);

  const updateChosenName = (value) => {
    setChosenList(value);
  };
  const AddToShopList = () => {
    if (quantityAddToShopList === "" || chosenList === null) {
      showAlert({ msgTitle: "הזן כמות להוספה", msgType: "error" });
      return;
    }
    dispatch(setPreload(true));

    addProductToList(chosenList, selectedProd.productId, quantityAddToShopList)
      .then((x) => {
        if (x.data) {
          showAlert({ msgTitle: "המוצר התווסף לרשימה", msgType: "success" });
          onAddSuccess?.(selectedProd.productId);
          close();
        } else {
          showAlert({ msgTitle: "המוצר לא התווסף", msgType: "error" });
        }
      })
      .catch(() => showAlert())
      .finally(() => dispatch(setPreload(false)));
  };

  return (
    <div className="product-add-to-shopping-list-pop-up">
      <header className="pasl-header">
        <h2 className="pasl-header__title">הוספה לרשימת קניות</h2>
        {selectedProd?.ProductName ? (
          <p className="pasl-header__product">{selectedProd.ProductName}</p>
        ) : null}
      </header>

      {listNames.length > 0 ? (
        <div className="pasl-form">
          <div className="pasl-field">
            <label className="pasl-label" htmlFor="pasl-list-select">
              רשימה
            </label>
            <select
              id="pasl-list-select"
              className="pasl-select"
              onChange={(e) => updateChosenName(e.target.value)}
              value={chosenList ?? ""}
            >
              {listNames.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div className="pasl-field pasl-field--qty">
            <label className="pasl-label" htmlFor="pasl-quantity">
              כמות
            </label>
            <input
              id="pasl-quantity"
              className="pasl-input"
              type="number"
              value={quantityAddToShopList}
              onChange={(e) => setQuantityAddToShopList(e.target.value)}
              onBlur={(e) => {
                const val = parseInt(e.target.value) || weightJump;
                const rounded = Math.round(val / weightJump) * weightJump;
                setQuantityAddToShopList(Math.max(weightJump, rounded));
              }}
              min={weightJump}
              step={weightJump}
            />
          </div>

          <button
            type="button"
            className="pasl-btn pasl-btn--primary"
            onClick={AddToShopList}
          >
            שמור
          </button>
        </div>
      ) : (
        <p className="pasl-empty">
          אין רשימות קניות. צור רשימה חדשה כדי להוסיף מוצרים.
        </p>
      )}

      <footer className="pasl-footer">
        <NavLink className="pasl-link" to="/shopping-list" onClick={close}>
          הוסף רשימת קניות חדשה
          <span className="pasl-link__chevron" aria-hidden>
            ‹
          </span>
        </NavLink>
      </footer>
    </div>
  );
};

export default ProductAddToShoppingList;
